/* istanbul ignore file */
import * as React from "react";
import type { SVGProps } from "react";
import PropTypes from "prop-types";

interface Props extends SVGProps<SVGSVGElement> {
  srText?: string;
  size?: "sm" | "md" | "lg" | "scale-8" | "scale-10" | number;
  alt?: string;
}
function IconFlowerPicture({
  srText,
  size = "md",
  className = "",
  ...props
}: Props) {
  const newClassName = `mc-icon mc-icon--${size} ${className}`;
  return (
    <>
      {!!srText && <span className="mc-sr-only">{srText}</span>}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        viewBox="0 0 24 24"
        aria-hidden="true"
        role="img"
        className={newClassName}
        {...props}
      >
        <defs>
          <clipPath id="flower-picture_svg__a">
            <path d="M0 .707h24v22.586H0Zm0 0" />
          </clipPath>
          <clipPath id="flower-picture_svg__b">
            <path d="M11 14h2v9.293h-2Zm0 0" />
          </clipPath>
        </defs>
        <g clipPath="url(#flower-picture_svg__a)">
          <path
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M14.5.999h-13A1 1 0 0 0 .5 2v13A1 1 0 0 0 1.5 16h13a1 1 0 0 0 1-1.001V2A1 1 0 0 0 14.5 1m0 0"
            transform="scale(1.5 1.41176)"
          />
        </g>
        <g clipPath="url(#flower-picture_svg__b)">
          <path
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M8 11.001v5"
            transform="scale(1.5 1.41176)"
          />
        </g>
        <path
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M9.125 9.715a.46.46 0 0 1 .086-.18q.06-.084.148-.133a.52.52 0 0 1 .388-.05 1.47 1.47 0 0 0 1.662-.34c.086-.29.08-.6-.016-.888a1.46 1.46 0 0 0-.518-.72.5.5 0 0 1-.112-.166.45.45 0 0 1-.042-.193q0-.105.042-.197a.5.5 0 0 1 .112-.163c.242-.183.424-.435.52-.722.095-.288.1-.598.014-.888a1.5 1.5 0 0 0-.776-.432 1.5 1.5 0 0 0-.886.091.5.5 0 0 1-.198.017.5.5 0 0 1-.19-.064.5.5 0 0 1-.148-.133.46.46 0 0 1-.086-.18C8.948 3.656 8.469 3.108 8 3.108c-.471 0-.948.548-1.125 1.268a.5.5 0 0 1-.086.18.503.503 0 0 1-.54.18 1.5 1.5 0 0 0-.882-.092 1.5 1.5 0 0 0-.776.432c-.088.29-.083.6.013.888.097.287.276.54.518.722a.494.494 0 0 1 0 .72 1.475 1.475 0 0 0-.53 1.607c.207.221.478.37.775.432.297.06.604.03.883-.092a.5.5 0 0 1 .198-.014.503.503 0 0 1 .341.194.6.6 0 0 1 .086.183c.177.716.654 1.267 1.125 1.267.469 0 .948-.548 1.125-1.267m0 0"
          transform="scale(1.5 1.41176)"
        />
        <path
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M8 8a1 1 0 1 0 0-2.001 1 1 0 0 0 0 2M5.807 14.247a3 3 0 0 1-1.112-.454c-1.177-.722-2.117-2.631-2.117-2.631a6.17 6.17 0 0 1 3.466.8M10.234 14.247a3 3 0 0 0 1.112-.454c1.177-.722 2.118-2.631 2.118-2.631a6.17 6.17 0 0 0-3.467.8"
          transform="scale(1.5 1.41176)"
        />
      </svg>
    </>
  );
}
IconFlowerPicture.propTypes = {
  srText: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
} as PropTypes.ValidationMap<Props>;
export default IconFlowerPicture;
